import { useState } from 'react'

import { useIncidentImageSelect } from './useIncidentImageSelect'
import { useToasts } from '@/hooks/useToasts'
import { useUpload } from '@/hooks/useUpload'
import * as Sentry from '@sentry/nextjs'

import { UploadedFileType } from '@/graphql/generated/schemas'

export const useIncidentImageUpload = () => {
  const { selectedFiles, handleFileSelect, removeFile, clearFiles } =
    useIncidentImageSelect()
  const [upload] = useUpload()
  const [isUploading, setIsUploading] = useState(false)
  const { showError } = useToasts()

  const uploadImages = async (): Promise<string[]> => {
    if (selectedFiles.length === 0) return []

    setIsUploading(true)
    try {
      const uploadPromises = selectedFiles.map((file) =>
        upload({
          file,
          fileType: UploadedFileType.IncidentImage,
        })
      )
      return await Promise.all(uploadPromises)
    } catch (error) {
      Sentry.captureException(error)
      showError('Failed to upload images')
      throw error
    } finally {
      setIsUploading(false)
    }
  }

  return {
    selectedFiles,
    handleFileSelect,
    removeFile,
    clearFiles,
    uploadImages,
    isUploading,
  }
}
